module.exports = __webpack_public_path__ + "static/img/spreadArt.f02d33d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spreadArt.png
// module id = 2CI5
// module chunks = 101